export default "__VITE_ASSET__WNhLuozY__"